export enum IGalleryOwners {
  Me = "me",
  Orher = "other",
  All = "all",
}
